import { APPROVE_COMPANY_DOCUMENTS, APPROVE_SERVICE } from "../../routes";
import customAxios from "../../customAxios";
import { Approve_Service_AdminiStrator } from "../../../types/common.type";

const approveCompanyDocuments = async (companyId: string) => {
  try {
    return (
      await customAxios.put(APPROVE_COMPANY_DOCUMENTS + "/" + companyId, {
        approve: true,
      })
    ).data;
  } catch (error: unknown) {
    console.error({ APPROVE_COMPANY_DOCUMENTS: error });
    return false;
  }
};

export default approveCompanyDocuments;
